/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React, { useEffect, useRef, useState } from "react";
// Redux Toolkit
import { useDispatch } from "react-redux";
// BASE components
import BASEPageSimple from "../../../@BASE/core/BASEPageSimple";
// Material-UI
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
// Custom Components
import ListingHeader from "../../shared-components/headers/ListingHeader";
import OrganizationsList from "./listing/OrganizationsList";
// actions
import useGroupedListing from "../../actions/useGroupedListing";
import { getListing } from "../../actions/index";
import { resetNavigation } from "../../store/BASE/navigationSlice";

const Root = styled(BASEPageSimple)(({ theme }) => ({
  "& .BASEPageSimple-header": {
    backgroundColor: theme.palette.background.royalBlue,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
}));

function OrganizationsPage() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const pageLayout = useRef(null);

  const { groupedData, searchTerm, setSearchTerm } = useGroupedListing(organizations, 'name', ['name']);

  // fetch Users
  const fetchOrganizations = async () => {
    try {
      const response = await dispatch(getListing('organizations')()).unwrap();
      setOrganizations(response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // get data from API on page load
  useEffect(() => {
    // get organizations
    fetchOrganizations();
    // reset navigation
    dispatch(resetNavigation());
  }, [dispatch]);

  if (!organizations || loading) {
    return (
      <CircularProgress />
    )
  }

  return (
    <Root
      header={<ListingHeader resource="Organizations" searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
      content={<OrganizationsList organizations={groupedData} />}
      ref={pageLayout}
      scroll="normal"
    />
  );
}

export default OrganizationsPage;
